const category = {
  teacher: {
    SIS: 'sis',
    ASSIGNMENT: 'assignment',
    PRINT: 'print',
    EMAIL: 'email',
    LOGIN: 'login',
    DEFAULT: 'default',
    ACTIVITIES: 'activities',
    REPORTS: 'reports',
    BENCHMARK: 'benchmark',
    TRACKING: 'tracking',
    PROGRESSMONITORING: 'progress',
    DIAGNOSTIC: 'diagnostic',
    DYSLEXIA: 'dyslexia',
    DYSLEXIARISK: 'dyslexiarisk',
    PARENT: 'parent',
    ADMIN: 'admin',
  },
  student: {
    DEFAULT: 'default',
    STUDENTHOME: 'studenthome',
    AUDIOCONTROLS: 'audiocontrols',
    REPORTS: 'reports',
    INTERVENTION: 'intervention',
    ASSESSMENT: 'assessment',
    TUTOR: 'tutor',
    HELP: 'help',
    LOGIN: 'login',
    REPORT: 'report',
    RECOMMENDATION: 'recommendation',
  },
};

export default category;